<ng-container *ngIf="costTypeState$ | async as state">

    <div class="cost-type-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <button mat-mini-fab
                    color="primary"
                    matTooltip="{{ 'app.page.cost-type-group.actions.add.label' | translate }}"
                    (click)="onOpenCostTypeGroupDialog()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.loading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" multiTemplateDataRows>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                        <button mat-icon-button *ngIf="!isExpandAll">
                            <mat-icon>keyboard_arrow_down</mat-icon>
                        </button>
                        <button mat-icon-button *ngIf="isExpandAll">
                            <mat-icon>keyboard_arrow_up</mat-icon>
                        </button>
                        {{"app.model.cost-type-group.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button aria-label="expand row" (click)="toggleExpand(element); $event.stopPropagation()">
                            <mat-icon *ngIf="!isExpandedMap[element.id]">keyboard_arrow_down</mat-icon>
                            <mat-icon *ngIf="isExpandedMap[element.id]">keyboard_arrow_up</mat-icon>
                        </button>
                        <span *ngIf="element.id !== null">{{element.name}}</span>
                        <span *ngIf="element.id === null">{{"app.model.cost-type-no-group.label" | translate}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit-button">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="group-actions">
                        <ng-container *ngIf="element.id !== null">
                            <button mat-icon-button
                                    matTooltip="{{ 'app.page.cost-type-group.actions.edit.label' | translate }}"
                                    (click)="onOpenCostTypeGroupDialog(element)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button
                                    color="warn"
                                    matTooltip="{{ 'app.page.cost-type-group.actions.delete.label' | translate }}"
                                    (click)="onDeleteCostTypeGroup(element)"
                                    [disabled]="element.costTypes.length !== 0">
                                <mat-icon>delete</mat-icon>
                            </button>

                            <button mat-mini-fab
                                    color="primary"
                                    matTooltip="{{ 'app.page.cost-type.actions.add.label' | translate }}"
                                    (click)="addCostTypeToGroup(element.id)">
                                <mat-icon>add</mat-icon>
                            </button>

                        </ng-container>
                    </td>
                </ng-container>


                <ng-container matColumnDef="expandedRow">
                    <td mat-cell *matCellDef="let costTypeGroup" [attr.colspan]="state.costTypeGroupColumns.length">
                        <div class="costType-detail" [@detailExpand]="isExpandedMap[costTypeGroup.id] ? 'expanded' : 'collapsed'">
                            <table mat-table [dataSource]="costTypeGroup.costTypes">


                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-type.name.label" | translate }}</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.name}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="type">
                                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-type.type.label" | translate }}</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ "app.model.cost-type.type-primary[" + element.isPrimary + "].label" | translate }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="ledgerAccountNr">
                                    <th mat-header-cell
                                        *matHeaderCellDef>{{ "app.model.cost-type.ledgerAccountNr.label" | translate }}</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{element.ledgerAccountNr}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="edit-button">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element" class="cost-type-actions">
                                        <button mat-icon-button
                                                color="primary"
                                                matTooltip="{{ 'app.page.cost-type.actions.edit.label' | translate }}"
                                                (click)="onOpenCostTypeDialog(element)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button mat-icon-button
                                                color="warn"
                                                matTooltip="{{ 'app.page.cost-type.actions.delete.label' | translate }}"
                                                (click)="onDeleteCostType(element)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="state.costTypeColumns;"></tr>
                                <tr mat-row *matRowDef="let row; columns: state.costTypeColumns"></tr>
                            </table>
                        </div>

                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="state.costTypeGroupColumns; sticky: true"
                    (click)="isExpandAll ? collapseAll() : expandAll()"></tr>
                <tr mat-row *matRowDef="let row; columns: state.costTypeGroupColumns;"
                    class="groupRow"
                    [class.example-expanded-row]="isExpandedMap[row.id]"
                    (click)="toggleExpand(row)"
                ></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedRow']" class="costtype-row"></tr>
            </table>
        </div>

    </div>


</ng-container>
